
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91key_93uG7_j19T3u3VeFQm56b1AYVNNv5YSE0u5pbWfK_45MDU4Meta } from "/src/pages/booking/[key].vue?macro=true";
import { default as datevCPoPJP5OC8UEKahxZhyCIttlIVEPXeY0un4LUpyacEMeta } from "/src/pages/check-in/date.vue?macro=true";
import { default as _91key_93CFcNvlSWvIu_45_EvI7BKjzRq3x5QbTuAtEP3hpM3bnloMeta } from "/src/pages/payment/[key].vue?macro=true";
import { default as confirmXzSqKh2p94f6BuvYlgHAs029FeLTLRxGl5f_458YahWsAMeta } from "/src/pages/booking/confirm.vue?macro=true";
import { default as successW4AdSAqOAmtoKzUiyQT1HQtrl_45n_7bonSbdbrN6fpIQMeta } from "/src/pages/booking/success.vue?macro=true";
import { default as resultpqa8PX3AxAxT0UZtnHMW4LLWHpts0ZanlP0KcRzmzRsMeta } from "/src/pages/check-in/result.vue?macro=true";
import { default as _91_91key_93_93V9xblFrQgqoqOmntiNPf17gkp5cevTcg65I0ZP9kmcAMeta } from "/src/pages/check-in/[[key]].vue?macro=true";
import { default as weightsr1Z5Gn7J_45tvo1vfadj7DWxFHriMpTDHEKSN12dBbslIMeta } from "/src/pages/check-in/weights.vue?macro=true";
import { default as preferencesEzRHJP1Xlp1mLSNxRGWPwrpu5nAK21gjSHFgNlOYn8oMeta } from "/src/pages/booking/preferences.vue?macro=true";
import { default as _91key_93sybavug6JQ3urojDQ_uR1F46QiSwblRILxLZdpNZCKQMeta } from "/src/pages/payment/result/[key].vue?macro=true";
import { default as preferred_time_POIISW8SiQxNIjpfSfa4_45RGgn0MOw_45WxHvZdnbrfygMeta } from "/src/pages/check-in/preferred_time.vue?macro=true";
import { default as personal_detailsWi1uo_45PGcE41_nVnwfI5c_1VP1hrC8Fd7M118ei1_WcMeta } from "/src/pages/booking/personal_details.vue?macro=true";
import { default as personal_detailsqcvQnvpKlapwviJzVzEA7UZymCjY_J7GP8bNQYtd_45MwMeta } from "/src/pages/check-in/personal_details.vue?macro=true";
export default [
  {
    name: "booking-key",
    path: "/booking/:key()",
    component: () => import("/src/pages/booking/[key].vue")
  },
  {
    name: "check-in-date",
    path: "/check-in/date",
    component: () => import("/src/pages/check-in/date.vue")
  },
  {
    name: "payment-key",
    path: "/payment/:key()",
    component: () => import("/src/pages/payment/[key].vue")
  },
  {
    name: "booking-confirm",
    path: "/booking/confirm",
    component: () => import("/src/pages/booking/confirm.vue")
  },
  {
    name: "booking-success",
    path: "/booking/success",
    component: () => import("/src/pages/booking/success.vue")
  },
  {
    name: "check-in-result",
    path: "/check-in/result",
    component: () => import("/src/pages/check-in/result.vue")
  },
  {
    name: "check-in-key",
    path: "/check-in/:key?",
    component: () => import("/src/pages/check-in/[[key]].vue")
  },
  {
    name: "check-in-weights",
    path: "/check-in/weights",
    component: () => import("/src/pages/check-in/weights.vue")
  },
  {
    name: "booking-preferences",
    path: "/booking/preferences",
    component: () => import("/src/pages/booking/preferences.vue")
  },
  {
    name: "payment-result-key",
    path: "/payment/result/:key()",
    component: () => import("/src/pages/payment/result/[key].vue")
  },
  {
    name: "check-in-preferred_time",
    path: "/check-in/preferred_time",
    component: () => import("/src/pages/check-in/preferred_time.vue")
  },
  {
    name: "booking-personal_details",
    path: "/booking/personal_details",
    component: () => import("/src/pages/booking/personal_details.vue")
  },
  {
    name: "check-in-personal_details",
    path: "/check-in/personal_details",
    component: () => import("/src/pages/check-in/personal_details.vue")
  }
]